export * from './readytosubmitirs.component';



// WEBPACK FOOTER //
// ./src/app/readytosubmitirs/index.ts